import { useCallback, useContext, useEffect, useState } from 'react';
import { AppContext } from 'providers/AppProvider';
import { FLOW_TYPE } from 'consts';
import { AutoOnboard, AutoSelect, CompanyTranslationKey, handleSubmit, HasNotFinishedMifid, SelectItem } from 'helpers';

export function useOnboard() {
	const ctx = useContext(AppContext);
	const { config, entityType, fetchRelations, flowType, Relations, state } = ctx;
	const { IS_EMPLOYEE_WEB } = config;
	const { context, user } = state;
	const { kennitala } = context;
	const { companyKennitala, isManualSignCompany } = user;
	const { children, companies, person } = Relations();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const prefix = `${flowType}_onboard_${entityType}`;
	const companyTranslationKey = CompanyTranslationKey(flowType, companies);
	const mifidURL = window.location.href.replace(`/${flowType}/`, `/${FLOW_TYPE.MV}/`);
	const unfinishedMifid = HasNotFinishedMifid(ctx.mifidStatus, flowType);
	const redirectToMifid = useCallback(() => (window.location.href = mifidURL), [mifidURL]);
	const onSelect = (ssn = '') => SelectItem(ssn, ctx);
	const onSubmit = () => handleSubmit(ctx, setIsModalOpen);

	useEffect(() => {
		fetchRelations();
	}, []); // eslint-disable-line

	useEffect(() => {
		AutoSelect(ctx, onSelect);
	}, [IS_EMPLOYEE_WEB, isManualSignCompany, companyKennitala]); // eslint-disable-line

	useEffect(() => {
		AutoOnboard(ctx);
	}, [kennitala, flowType, IS_EMPLOYEE_WEB, companies, person.disabledCard]); // eslint-disable-line

	return {
		...ctx,
		children,
		companies,
		companyTranslationKey,
		entityType,
		flowType,
		isModalOpen,
		kennitala,
		mifidURL,
		onSelect,
		onSubmit,
		person,
		prefix,
		redirectToMifid,
		unfinishedMifid
	};
}
